import { BriefcaseIcon, XIcon } from 'lucide-react';

import { useLanguage } from '@/contexts/language-context';
import { Button } from '@/components/ui/button';

import { JobCard } from './job-card';
import type { Job } from './types';

interface Props {
  jobs: Job[];
  hasFilters: boolean;
  onClearFilters: () => void;
  onSelect: (jobId: string) => void;
  onCopy: (job: Job) => void;
}

export function JobsGrid({ jobs, hasFilters, onClearFilters, onSelect, onCopy }: Props) {
  const { t } = useLanguage();

  if (jobs.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 gap-3 text-center border rounded-xl bg-card">
        <BriefcaseIcon className="w-10 h-10 text-muted-foreground/40" />
        <p className="font-medium text-sm">{t.noJobsFound}</p>
        <p className="text-xs text-muted-foreground">{t.noJobsDescription}</p>
        {hasFilters && (
          <Button
            variant="outline"
            size="sm"
            onClick={onClearFilters}
            className="mt-1 gap-1.5"
          >
            <XIcon className="w-3.5 h-3.5" />
            {t.clearFilters}
          </Button>
        )}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
      {jobs.map((job) => (
        <JobCard key={job.id} job={job} onSelect={onSelect} onCopy={onCopy} />
      ))}
    </div>
  );
}
